import { cloneElement } from "react";

/*
    Hook to pass an object of props down to all children components 
        - Does not pass props to non-component children, like null and jsx

    props
        (children, required)  children       The children to pass the props to
        (object, optional)    childrenProps  The object of props to pass to the children
                                                - Example = {
                                                    className: "something",
                                                    onChange: doSomething,
                                                    ...rest
                                                }
 
    returns
        (children)  childrenWithProps
*/

const useChildrenProps = (children, childrenProps = {}) => {
  // When there is only 1 child, convert it from an object to an array so we can map it
  let mapableChildren = children;
  if (typeof mapableChildren === "string" || typeof mapableChildren !== "string" && !mapableChildren?.length) {
    mapableChildren = [mapableChildren];
  }

  // Filter out children that shouldn't be shown like undefined or null
  const filteredMapableChildren = mapableChildren.filter(child => child !== null && child !== false && typeof child !== "undefined");
  const childrenWithProps = filteredMapableChildren[0] && filteredMapableChildren.map((child, index) => {
    // If the child is a function, we can assume it is a react component and give it props
    if (typeof child?.type === "function") {
      return /*#__PURE__*/cloneElement(child, {
        ...childrenProps,
        key: index
      });
    }
    // Else, dont give the child props
    return child;
  });
  return [childrenWithProps];
};
export { useChildrenProps };